import { Component, Inject, Input } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { Mention } from '../../models/mention';

@Component({
    selector: 'agpr-financial-times-attribution',
    templateUrl: './financial-times-attribution.component.html',
    styleUrls: ['./financial-times-attribution.component.scss'],
    standalone: false
})
export class FinancialTimesAttributionComponent {
    @Input() mention: Mention;

    constructor(@Inject(APP_BASE_HREF) public appBaseHref: string) {}
}
